var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _linearGradient, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient0, _linearGradient2, _linearGradient3, _linearGradient4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirefox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 71.531,
    cy: 16.385,
    gradientUnits: "userSpaceOnUse",
    r: 90.78
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff36e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fc4055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e31587"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 6.629,
    cy: 20.14,
    gradientUnits: "userSpaceOnUse",
    r: 53.726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#c60084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc4055",
    stopOpacity: 0
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 79.291,
    cy: 11.219,
    gradientUnits: "userSpaceOnUse",
    r: 106.599
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffde67",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#ffd966",
    stopOpacity: 0.581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#ffca65",
    stopOpacity: 0.525
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#feb262",
    stopOpacity: 0.432
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#fe8f5e",
    stopOpacity: 0.302
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#fd6459",
    stopOpacity: 0.137
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#fc4055",
    stopOpacity: 0
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 42.285,
    cy: 44.404,
    gradientUnits: "userSpaceOnUse",
    r: 137.521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#810220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#920b27",
    stopOpacity: 0.861
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#cb2740",
    stopOpacity: 0.398
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#ef394f",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#fc4055",
    stopOpacity: 0
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 31.878,
    cy: 42.675,
    gradientUnits: "userSpaceOnUse",
    r: 137.521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#810220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#920b27",
    stopOpacity: 0.861
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#cb2740",
    stopOpacity: 0.398
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257,
    stopColor: "#ef394f",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#fc4055",
    stopOpacity: 0
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 45.831,
    x2: 69.389,
    y1: 7.787,
    y2: 48.591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbd4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#ff9640",
    stopOpacity: 0
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: -1255.933,
    cy: -77.395,
    gradientTransform: "matrix(.959 0 0 .961 1273.896 86.468)",
    gradientUnits: "userSpaceOnUse",
    r: 88.863
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fc4055"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: -1255.933,
    cy: -77.395,
    gradientTransform: "matrix(.959 0 0 .961 1273.896 86.468)",
    gradientUnits: "userSpaceOnUse",
    r: 88.863
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#ffde67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.147,
    stopColor: "#ffdc66",
    stopOpacity: 0.968
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#ffd562",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#ffcb5d",
    stopOpacity: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#ffbc55",
    stopOpacity: 0.533
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#ffaa4b",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#ff9640",
    stopOpacity: 0
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 49.941,
    cy: 38.654,
    gradientTransform: "matrix(.247 .971 -1.011 .259 76.681 -19.851)",
    gradientUnits: "userSpaceOnUse",
    r: 41.79
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#fc4055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#fd604d",
    stopOpacity: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#fe8644",
    stopOpacity: 0.181
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#ff9640",
    stopOpacity: 0
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 42.737,
    cy: 42.098,
    gradientUnits: "userSpaceOnUse",
    r: 41.79
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#fc4055",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#fd5251",
    stopOpacity: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fe8345",
    stopOpacity: 0.181
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#ff9640",
    stopOpacity: 0
  }))), _radialGradient0 || (_radialGradient0 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: -1238.198,
    cy: -87.433,
    gradientTransform: "matrix(.959 0 0 .961 1273.896 86.468)",
    gradientUnits: "userSpaceOnUse",
    r: 150.195
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#fff36e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#ff9640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#ff9640"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 59.052,
    x2: 18.155,
    y1: 7.083,
    y2: 77.92
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff36e",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#fff36e",
    stopOpacity: 0.699
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#fff36e",
    stopOpacity: 0
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 40.585,
    x2: 62.3,
    y1: -0.67,
    y2: 62.203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b833e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#9059ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    stopColor: "#5b6df8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ed"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 27.71,
    x2: 68.071,
    y1: 0.324,
    y2: 40.685
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#722291",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#592acb",
    stopOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m71.944 15.7a39.47 39.47 0 0 0 -30.356-15.691c-9.288-.186-15.704 2.605-19.334 4.849 4.857-2.817 11.886-4.415 18.04-4.336 15.83.2 32.832 10.981 35.357 30.413 2.9 22.306-12.637 40.923-34.493 40.98-24.045.061-38.67-21.229-34.847-40.352a19.735 19.735 0 0 1 .413-2.787 37.815 37.815 0 0 1 4.193-14.018c-2.769 1.433-6.295 5.965-8.035 10.163a41.355 41.355 0 0 0 -2.598 20.179c.06.518.114 1.035.182 1.549a40.062 40.062 0 1 0 71.478-30.949z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m71.944 15.7a39.47 39.47 0 0 0 -30.356-15.691c-9.288-.186-15.704 2.605-19.334 4.849 4.857-2.817 11.886-4.415 18.04-4.336 15.83.2 32.832 10.981 35.357 30.413 2.9 22.306-12.637 40.923-34.493 40.98-24.045.061-38.67-21.229-34.847-40.352a19.735 19.735 0 0 1 .413-2.787 37.815 37.815 0 0 1 4.193-14.018c-2.769 1.433-6.295 5.965-8.035 10.163a41.355 41.355 0 0 0 -2.598 20.179c.06.518.114 1.035.182 1.549a40.062 40.062 0 1 0 71.478-30.949z",
    fill: "url(#b)",
    opacity: 0.67
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m71.944 15.7a39.47 39.47 0 0 0 -30.356-15.691c-9.288-.186-15.704 2.605-19.334 4.849 4.857-2.817 11.886-4.415 18.04-4.336 15.83.2 32.832 10.981 35.357 30.413 2.9 22.306-12.637 40.923-34.493 40.98-24.045.061-38.67-21.229-34.847-40.352a19.735 19.735 0 0 1 .413-2.787 37.815 37.815 0 0 1 4.193-14.018c-2.769 1.433-6.295 5.965-8.035 10.163a41.355 41.355 0 0 0 -2.598 20.179c.06.518.114 1.035.182 1.549a40.062 40.062 0 1 0 71.478-30.949z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m71.944 15.7a39.47 39.47 0 0 0 -30.356-15.691c-9.288-.186-15.704 2.605-19.334 4.849 4.857-2.817 11.886-4.415 18.04-4.336 15.83.2 32.832 10.981 35.357 30.413 2.9 22.306-12.637 40.923-34.493 40.98-24.045.061-38.67-21.229-34.847-40.352a19.735 19.735 0 0 1 .413-2.787 37.815 37.815 0 0 1 4.193-14.018c-2.769 1.433-6.295 5.965-8.035 10.163a41.355 41.355 0 0 0 -2.598 20.179c.06.518.114 1.035.182 1.549a40.062 40.062 0 1 0 71.478-30.949z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m71.944 15.7a39.47 39.47 0 0 0 -30.356-15.691c-9.288-.186-15.704 2.605-19.334 4.849 4.857-2.817 11.886-4.415 18.04-4.336 15.83.2 32.832 10.981 35.357 30.413 2.9 22.306-12.637 40.923-34.493 40.98-24.045.061-38.67-21.229-34.847-40.352a19.735 19.735 0 0 1 .413-2.787 37.815 37.815 0 0 1 4.193-14.018c-2.769 1.433-6.295 5.965-8.035 10.163a41.355 41.355 0 0 0 -2.598 20.179c.06.518.114 1.035.182 1.549a40.062 40.062 0 1 0 71.478-30.949z",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m75.651 30.935a41.01 41.01 0 0 1 .3 7.247q1.99-.3 3.987-.53a40.01 40.01 0 0 0 -7.994-21.952 39.47 39.47 0 0 0 -30.356-15.691c-9.288-.186-15.704 2.605-19.334 4.849 4.857-2.817 11.886-4.415 18.04-4.336 15.83.202 32.832 10.978 35.357 30.413z",
    fill: "url(#f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m76.625 29.826c-2.251-20.308-20.362-29.436-36.331-29.304-6.155.05-13.183 1.519-18.04 4.336a19.7 19.7 0 0 0 -3.56 2.7c.129-.107.514-.424 1.152-.862l.063-.043.056-.038a26.655 26.655 0 0 1 7.692-3.572 43.5 43.5 0 0 1 13.183-1.543 33.254 33.254 0 0 1 31.25 31.993c.367 13.207-10.442 23.737-22.902 24.347-9.062.444-17.6-3.941-21.77-12.713a21.68 21.68 0 0 1 -1.964-6.333c-1.976-13.35 6.989-24.735 15.21-27.554-4.435-3.874-15.548-3.611-23.819 2.474-5.956 4.382-9.82 11.049-11.1 19a32.945 32.945 0 0 0 2.34 18 35.3 35.3 0 0 0 30.089 21.443q1.489.114 2.984.113c26.462 0 37.942-20.087 35.467-42.444z",
    fill: "url(#g)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m76.625 29.826c-2.251-20.308-20.362-29.436-36.331-29.304-6.155.05-13.183 1.519-18.04 4.336a19.7 19.7 0 0 0 -3.56 2.7c.129-.107.514-.424 1.152-.862l.063-.043.056-.038a26.655 26.655 0 0 1 7.692-3.572 43.5 43.5 0 0 1 13.183-1.543 33.254 33.254 0 0 1 31.25 31.993c.367 13.207-10.442 23.737-22.902 24.347-9.062.444-17.6-3.941-21.77-12.713a21.68 21.68 0 0 1 -1.964-6.333c-1.976-13.35 6.989-24.735 15.21-27.554-4.435-3.874-15.548-3.611-23.819 2.474-5.956 4.382-9.82 11.049-11.1 19a32.945 32.945 0 0 0 2.34 18 35.3 35.3 0 0 0 30.089 21.443q1.489.114 2.984.113c26.462 0 37.942-20.087 35.467-42.444z",
    fill: "url(#h)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m76.625 29.826c-2.251-20.308-20.362-29.436-36.331-29.304-6.155.05-13.183 1.519-18.04 4.336a19.7 19.7 0 0 0 -3.56 2.7c.129-.107.514-.424 1.152-.862l.063-.043.056-.038a26.655 26.655 0 0 1 7.692-3.572 43.5 43.5 0 0 1 13.183-1.543 33.254 33.254 0 0 1 31.25 31.993c.367 13.207-10.442 23.737-22.902 24.347-9.062.444-17.6-3.941-21.77-12.713a21.68 21.68 0 0 1 -1.964-6.333c-1.976-13.35 6.989-24.735 15.21-27.554-4.435-3.874-15.548-3.611-23.819 2.474-5.956 4.382-9.82 11.049-11.1 19a32.945 32.945 0 0 0 2.34 18 35.3 35.3 0 0 0 30.089 21.443q1.489.114 2.984.113c26.462 0 37.942-20.087 35.467-42.444z",
    fill: "url(#i)",
    opacity: 0.53
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m76.625 29.826c-2.251-20.308-20.362-29.436-36.331-29.304-6.155.05-13.183 1.519-18.04 4.336a19.7 19.7 0 0 0 -3.56 2.7c.129-.107.514-.424 1.152-.862l.063-.043.056-.038a26.655 26.655 0 0 1 7.692-3.572 43.5 43.5 0 0 1 13.183-1.543 33.254 33.254 0 0 1 31.25 31.993c.367 13.207-10.442 23.737-22.902 24.347-9.062.444-17.6-3.941-21.77-12.713a21.68 21.68 0 0 1 -1.964-6.333c-1.976-13.35 6.989-24.735 15.21-27.554-4.435-3.874-15.548-3.611-23.819 2.474-5.956 4.382-9.82 11.049-11.1 19a32.945 32.945 0 0 0 2.34 18 35.3 35.3 0 0 0 30.089 21.443q1.489.114 2.984.113c26.462 0 37.942-20.087 35.467-42.444z",
    fill: "url(#j)",
    opacity: 0.53
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m49.188 57.84c17.1-1.04 24.42-15.2 24.879-25.245.716-15.695-8.595-32.615-33.227-31.095a43.5 43.5 0 0 0 -13.183 1.546 28.855 28.855 0 0 0 -7.692 3.572l-.056.038-.063.043q-.574.4-1.123.842a33.482 33.482 0 0 1 20.977-3.936c14.142 1.856 27.072 12.857 27.072 27.373 0 11.169-8.631 19.7-18.738 19.087-15.015-.9-18.8-16.3-10.989-22.954-2.106-.453-6.064.435-8.82 4.555-2.473 3.7-2.333 9.41-.807 13.461a22.118 22.118 0 0 0 21.77 12.713z",
    fill: "url(#k)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m71.944 15.7a39.958 39.958 0 0 0 -3.482-3.982 31.342 31.342 0 0 0 -3.177-2.926 24.393 24.393 0 0 1 1.849 1.79 22.466 22.466 0 0 1 4.882 8.144c2.089 6.329 1.953 14.25-2.036 20.471a23.539 23.539 0 0 1 -20.855 10.895c-.361 0-.725 0-1.091-.027-15.015-.9-18.8-16.3-10.988-22.954-2.107-.453-6.065.435-8.821 4.555-2.473 3.7-2.333 9.41-.807 13.461a21.679 21.679 0 0 1 -1.963-6.333c-1.977-13.35 6.988-24.735 15.209-27.554-4.435-3.874-15.548-3.611-23.819 2.474a27.845 27.845 0 0 0 -10.087 14.6 38.5 38.5 0 0 1 4.159-13.553c-2.769 1.433-6.295 5.965-8.035 10.163a41.355 41.355 0 0 0 -2.598 20.176c.06.518.114 1.035.182 1.549a40.062 40.062 0 1 0 71.478-30.949z",
    fill: "url(#l)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m72.016 18.726a22.458 22.458 0 0 0 -4.882-8.144 30.224 30.224 0 0 0 -9.094-6.493 40.518 40.518 0 0 0 -8.94-3.169 39.834 39.834 0 0 0 -16.565-.1c-5.683 1.2-10.68 3.659-13.841 6.733a32.1 32.1 0 0 1 8.031-3.2 33.565 33.565 0 0 1 31.173 8.1 27.01 27.01 0 0 1 4.329 5.3c4.895 7.959 4.432 17.965.615 23.866-2.835 4.384-8.907 8.5-14.572 8.452a23.629 23.629 0 0 0 21.71-10.871c3.989-6.224 4.125-14.145 2.036-20.474z",
    fill: "url(#m)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m72.016 18.726a22.458 22.458 0 0 0 -4.882-8.144 30.224 30.224 0 0 0 -9.094-6.493 40.518 40.518 0 0 0 -8.94-3.169 39.834 39.834 0 0 0 -16.565-.1c-5.683 1.2-10.68 3.659-13.841 6.733a32.1 32.1 0 0 1 8.031-3.2 33.565 33.565 0 0 1 31.173 8.1 27.01 27.01 0 0 1 4.329 5.3c4.895 7.959 4.432 17.965.615 23.866-2.835 4.384-8.907 8.5-14.572 8.452a23.629 23.629 0 0 0 21.71-10.871c3.989-6.224 4.125-14.145 2.036-20.474z",
    fill: "url(#n)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.0d2b9a7f6ecc571ff178edaa1499917a.svg";
export { ForwardRef as ReactComponent };